import fjGallery from './plugins/fjGallery';
import { tns } from './plugins/tiny-slider';
import ToggleElement from './modules/toggleElement';
import FormStyler from "./modules/formStyler";
import Tabs from "./modules/tabs";

window.addEventListener('DOMContentLoaded', () => {

  /*******************************************************/
  // Sidebar Mobile Toggle
  /*******************************************************/
  new ToggleElement('.main-title__icon', '.sidebar', 'sidebar_open');

  /*******************************************************/
  // Search Toggle
  /*******************************************************/
  new ToggleElement('.search-icon', '.search__field', 'search__field_open');

  /*******************************************************/
  // Full Photo Info
  /*******************************************************/
  const fullPhotoInfo = document.querySelector('.full-photo-info');

  if (fullPhotoInfo) {
    new ToggleElement('.js-info-toggle-btn', '.full-photo-info', 'full-photo-info_open');
  }

  /*******************************************************/
  // Content Filter
  /*******************************************************/
  const filter = document.querySelector('.filter-btn');

  if (filter) {
    new ToggleElement('.filter-btn', '.filter', 'filter_open', 'active');
  }

  /*******************************************************/
  // Form Styles
  /*******************************************************/
  new FormStyler('select.filter__dropdown');

  /*******************************************************/
  // Content Tabs
  /*******************************************************/
  new Tabs('.content__tab-btns a', '.content__tab', 'active');

  /*******************************************************/
  // Albums Content
  /*******************************************************/
  const photoGallery = document.querySelectorAll('.photo-items');

  if (photoGallery){
    fjGallery(photoGallery, {
      itemSelector: '.photo-item',
      calculateItemsHeight: true,
      gutter: { horizontal: 10, vertical: 10 }
    });
  }

  /*******************************************************/
  // Main Slider
  /*******************************************************/
  const mainSlider = document.querySelector('.main-slider');

  if (mainSlider) {
    const slider = tns({
      container: '.js-main-owl-carousel',
      items: 1,
      nav: false,
      navSpeed: 100,
      loop: false,
      mode: "gallery",
      autoHeight:true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      speed: 1000
    });
  }

});









